// @ts-strict-ignore
import { getFakeGetFetcherFunctions } from "../../fakingUtils";

import { appsAppGroupIdChartsSessionsLifetimeStats } from "../constants";
import { fakeAppGroupSessionLifetimeStatsResults } from "./constants";
import { getAppGroupSessionLifetimeStats } from "../getAppGroupSessionLifetimeStats";

/**
 * A fake fetcher function, for use in faking the "/apps/:app_group_id/charts/sessions/lifetime_stats" GET endpoint in storybook
 * using <FakeDashboardApiProvider>
 */
const fakeGetAppGroupSessionLifetimeStatsFetchers = getFakeGetFetcherFunctions({
  cacheKey: appsAppGroupIdChartsSessionsLifetimeStats,
  baseFakeThing: fakeAppGroupSessionLifetimeStatsResults,
  realFetcher: getAppGroupSessionLifetimeStats,
});

export { fakeGetAppGroupSessionLifetimeStatsFetchers };
